import { TestCodeModalContent } from './TestCodeModalContent';
export default TestCodeModalContent;